import React from "react";
import { Link } from "react-router-dom";
import { FaCheckCircle } from "react-icons/fa";
import { Translate } from "react-redux-i18n";

import "./styles/RegisterSuccessfull.css";

class PasswordForgetSend extends React.Component {
  render() {
    return (
      <div className="register-success-page">
        <div className="register-success-card">
          <div className="register-success-card__icon" aria-hidden="true">
            <FaCheckCircle />
          </div>

          <h1 className="register-success-card__title">
            <Translate value="password_forget_email_send" />
          </h1>

          <p className="register-success-card__text">
            <Translate value="confirm_reset_password" />
          </p>

          <Link to="/login" className="register-success-card__button">
            <Translate value="login" />
          </Link>

          <p className="register-success-card__footer">
            <Translate value="password_forget_email" />{" "}
            <a href="mailto:team@godiway.com?subject=Godiwayer">
              team@godiway.com
            </a>
          </p>
        </div>
      </div>
    );
  }
}

export default PasswordForgetSend;
